// extracted by mini-css-extract-plugin
module.exports = {"modal":"bYgL_bS5","darkModal":"TKLKgIn3"};